import { Button, KIND, SIZE } from 'baseui/button'
import { Search } from 'baseui/icon'
import { useTranslation } from 'react-i18next'
import usePceSearchV2 from './usePceSearchV2'

const PceSearchButton = ({ hidden = false }) => {
  const { t } = useTranslation()
  const { updatePceConfigData } = usePceSearchV2()

  const handleOpenModal = () => {
    updatePceConfigData({ isOpen: true })
  }

  if (hidden) return null

  return (
    <Button
      overrides={{
        BaseButton: {
          style: () => ({
            marginTop: '0.2rem',
            backgroundColor: '#F09741',
            color: 'black',
            ':hover': {
              backgroundColor: '#e8873a',
            },
          }),
        },
        StartEnhancer: {
          style: () => ({
            marginRight: '0.2rem',
          }),
        },
      }}
      kind={KIND.secondary}
      size={SIZE.mini}
      startEnhancer={() => <Search size={18} />}
      id='pce-search-open-modal'
      onClick={handleOpenModal}
    >
      {t('subscriptionForm:pce_module.search_text')}
    </Button>
  )
}

export default PceSearchButton
